import React from "react";
import Navbar from "react-bootstrap/Navbar";
import Nav from "react-bootstrap/Nav";
// import Logo from "../../assets/icons/logow.webp";
import "./my-navbar.styles.css";

const MyNavbar = () => {
  const toggleBar = () => { document.getElementById('navbarToggle').click(); };
  return (
    <div>
      <Navbar
        fixed="top"
        variant="dark"
        expand="md"
        className="animate-navbar nav-theme justify-content-between"
      >
        <div>
          <Navbar.Toggle id="navbarToggle" aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="mr-auto ">
              <Nav.Link onClick={toggleBar} href="#home">Home</Nav.Link>
              <Nav.Link onClick={toggleBar} href="#about">About</Nav.Link>
              <Nav.Link onClick={toggleBar} href="#skills">Skills</Nav.Link>
              <Nav.Link onClick={toggleBar} href="#experience">Experience</Nav.Link>
              <Nav.Link onClick={toggleBar} href="#projects">Projects</Nav.Link>
              <Nav.Link onClick={toggleBar} href="#contact">Contact</Nav.Link>
            </Nav>
          </Navbar.Collapse>
        </div>
      </Navbar>
    </div>
  );
};

export default MyNavbar;
